import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Loading from '../components/Loading';

const AuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = searchParams.get('token');
    const shop = searchParams.get('shop');
    const errorMessage = searchParams.get('error');

    if (errorMessage) {
      setError(decodeURIComponent(errorMessage));
      return;
    }

    if (token && shop) {
      try {
        login(token, { shop: shop, scope: 'read_orders,read_products,read_customers' });
        navigate('/', { replace: true });
      } catch (err) {
        setError('Failed to complete authentication');
      }
    } else {
      setError('Invalid authentication response');
    }
  }, [searchParams, login, navigate]);

  if (error) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: '20px',
        padding: '20px',
        textAlign: 'center'
      }}>
        <h1 style={{ color: '#bf0711' }}>Authentication Failed</h1>
        <p>{error}</p>
        <button
          onClick={() => window.location.href = '/'}
          style={{
            padding: '10px 20px',
            backgroundColor: '#008060',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px'
          }}
        >
          Try Again
        </button>
      </div>
    );
  }

  return <Loading message="Completing authentication..." />;
};

export default AuthCallback;
